/* eslint-disable jsx-a11y/alt-text */
import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';

const StarIcons = ({
  size,
  stars,
  rating,
  secondaryColors,
  halfStar,
  className,
}) => {
  const { market } = useContext(AppContext);

  return (
    <div
      style={{
        width: (size + 1) * stars.length,
        lineHeight: 0,
      }}
      className={className}
    >
      {stars.map(star => {
        const cdn = market && market.cdn ? market.cdn : 'https://cdn.pji.nu';
        let file = 'empty';

        if (halfStar && rating.whole === star) {
          file = secondaryColors ? 'alt-half' : 'primary-half';
        } else if (rating.whole >= star) {
          file = secondaryColors ? 'alt-full' : 'primary-full';
        }

        return (
          <img
            key={`star-${star}`}
            style={{
              width: size,
              marginRight: '1px',
            }}
            src={`${cdn}/g/rfe/icons/stars/${file}.svg`}
            alt=""
          />
        );
      })}
    </div>
  );
};

StarIcons.propTypes = {
  size: PropTypes.number,
  stars: PropTypes.arrayOf(PropTypes.number).isRequired,
  rating: PropTypes.shape({
    real: PropTypes.number,
    rounded: PropTypes.number,
    whole: PropTypes.number,
  }).isRequired,
  secondaryColors: PropTypes.bool,
  halfStar: PropTypes.bool,
  className: PropTypes.string,
};

StarIcons.defaultProps = {
  size: 16,
  secondaryColors: true,
  halfStar: false,
  className: undefined,
};

export default memo(StarIcons);
